import { render, staticRenderFns } from "./normal-share.vue?vue&type=template&id=06134680&scoped=true"
import script from "./normal-share.vue?vue&type=script&lang=js"
export * from "./normal-share.vue?vue&type=script&lang=js"
import style0 from "./normal-share.vue?vue&type=style&index=0&id=06134680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06134680",
  null
  
)

export default component.exports